import { ArrowDown, ArrowUp, Equal } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ModelCandidate } from "@/services/adminModelCurrency";
import { compareWithCurrent, type Verdict } from "./compareHelpers";

const VERDICT: Record<Verdict, { word: string; icon: typeof ArrowUp; tone: string }> = {
  better: {
    word: "Better than",
    icon: ArrowUp,
    tone: "border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-200",
  },
  worse: {
    word: "Worse than",
    icon: ArrowDown,
    tone: "border-red-200 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-200",
  },
  same: {
    word: "About the same as",
    icon: Equal,
    tone: "border-border bg-muted/50 text-foreground",
  },
};

/** "Better than gpt-6-luna · title relevance 4.87 vs 4.77 out of 5". Nothing when there is no side-by-side. */
const ComparisonLine = ({ candidate }: { candidate: ModelCandidate }) => {
  const comparison = compareWithCurrent(candidate);
  if (!comparison) return null;
  const { word, icon: Icon, tone } = VERDICT[comparison.verdict];
  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border px-3 py-2 text-sm",
        tone
      )}
    >
      <span className="flex items-center gap-1.5 font-semibold">
        <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
        {word} <span className="font-mono">{comparison.against}</span>
      </span>
      <span className="tabular-nums">
        {comparison.metric}: <strong>{comparison.candidate}</strong> vs {comparison.current}{" "}
        {comparison.scale}
      </span>
    </div>
  );
};

export default ComparisonLine;
